import { DesignTokens, ErrorIcon, LoadingIcon, SuccessIcon } from "melco-ui";
import {
  NotificationStatus,
  notificationStatusToName,
} from "../../helper/notificationStatus";

const { colors } = DesignTokens;

type NotificationIconProps = {
  status: NotificationStatus;
};

export const NotificationStatusIcon: React.FC<NotificationIconProps> = ({
  status,
}) => {
  const statusName = notificationStatusToName(status);

  //There is no status "processing"
  if (statusName === "queued") {
    return <LoadingIcon style={{ color: colors.main.primary }} />;
  }
  if (statusName === "error") {
    return <ErrorIcon style={{ color: colors.feedback.error }} />;
  }
  if (statusName === "success") {
    return <SuccessIcon style={{ color: colors.feedback.success }} />;
  }

  return null;
};
